module.exports = __webpack_public_path__ + "img/bespoke70_23.66d58754.jpg";